// Microsoft sign-in opens a popup (or a hidden frame, when renewing a token quietly) and, when it's done, sends it back
// to this site with the answer in the URL hash. The page that opened it reads that hash straight out of the popup.
//
// The router also lives in the hash, so if the app started up inside that popup it would rewrite the hash and the answer
// would be lost: sign-in would hang. So in that situation the app must not start; it just waits to be closed.

interface WindowLike {
  opener: unknown;
  parent: unknown;
  location: { hash: string; search: string };
}

const looksLikeAuthResponse = (params: string): boolean => {
  const p = new URLSearchParams(params);
  return p.has('state') && (p.has('code') || p.has('error'));
};

/** True when this window was opened by a sign-in flow and is carrying its answer. */
export function isAuthResponseWindow(win: WindowLike = window as unknown as WindowLike): boolean {
  const insideAnother = !!win.opener || win.parent !== win;
  if (!insideAnother) return false;
  return looksLikeAuthResponse(win.location.hash.replace(/^#/, '')) || looksLikeAuthResponse(win.location.search.replace(/^\?/, ''));
}
